import React, { useContext, useEffect } from 'react';
// Components & Utils
import ShadowBackgroundTextBanner from '../components/faq/ShadowBackgroundTextBanner';
// UI
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { UIContext } from '../providers/UIProvider';
import useDocumentTitle from '../hooks/useDocumentTitle';

/**
 * @function TermsAndContiions
 * @author RCH010
 * @version 1.0
 * @description TermsAndContiions view
 * This component doesn't uses ViewContainer because of the desired effect of the FAQBanner
 * View contains a tabs container with all the questions in accordions
 * And a DownloadAppSection and Contact form
 * @returns {JSX}
 */
const TermsAndConditions = () => {
  const theme = useTheme();
  useDocumentTitle('Oasis App - Términos y condiciones');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { setNavbarBackgroundColor } = useContext(UIContext);

  useEffect(() => {
    setNavbarBackgroundColor(theme.palette.lightBackground);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box
      sx={{
        bgcolor: (currTheme) => currTheme.palette.lightBackground,
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
      }}>
      <ShadowBackgroundTextBanner
        text={`Términos ${isMobile ? '\n' : ''}y Condiciones`}
      />
      <Box
        sx={{
          bgcolor: (currTheme) => currTheme.palette.mainBackground,
        }}>
        <Box
          sx={{
            px: 3,
            maxWidth: 'lg',
            mx: 'auto',
            py: 8,
          }}>
          <embed src="https://oasis-starter-storage.s3.us-west-1.amazonaws.com/legalDocuments/Oasis_Terminos_y_Condiciones.pdf#toolbar=0" 
            style={{width:'100%', height:'calc(100dvh - 100px)'}} 
            type="application/pdf">
          </embed>
        </Box>
      </Box>
    </Box>
  );
};

export default TermsAndConditions;
